define((require) => {
    "use strict";

    const Enum                   = require("shared/util/Enum");
    const OpacityEffect          = require("shared/ui/experience/widgets/effects/OpacityEffect");
    const OpacityEffectModel     = require("shared/ui/experience/action/effects/OpacityEffectModel");
    const ScaleEffect            = require("shared/ui/experience/widgets/effects/ScaleEffect");
    const ScaleEffectModel       = require("shared/ui/experience/action/effects/ScaleEffectModel");
    const RotateEffect           = require("shared/ui/experience/widgets/effects/RotateEffect");
    const RotateEffectModel      = require("shared/ui/experience/action/effects/RotateEffectModel");
    const PulseEffect            = require("shared/ui/experience/widgets/effects/PulseEffect");
    const PulseEffectModel       = require("shared/ui/experience/action/effects/PulseEffectModel");
    const ImageToggleEffect      = require("shared/ui/experience/widgets/effects/ImageToggleEffect");
    const ImageToggleEffectModel = require("shared/ui/experience/action/effects/ImageToggleEffectModel");

    // Create the backing map like this because we reuse keys from the EffectModel enum...
    const map = {};

    map[OpacityEffectModel.TYPE]     = OpacityEffect;
    map[ScaleEffectModel.TYPE]       = ScaleEffect;
    map[RotateEffectModel.TYPE]      = RotateEffect;
    map[PulseEffectModel.TYPE]       = PulseEffect;
    map[ImageToggleEffectModel.TYPE] = ImageToggleEffect;

    /**
     * A enum describing all effect types, not effect models, where each type can have numerous instances. <p>
     *
     * The returned enum will index each effect type via the static defined <tt>TYPE</tt> property in the
     * corresponding <tt>EffectModel</tt> type, e.g. {.., ScaleEffectModel.TYPE: ScaleEffect, ..}, where the described
     * value of the key in this example is "scale". <p>
     *
     * To create a new effect based on an effect model, simply do:
     * <pre>
     *    ..
     *    var someEffectModel = ..; // effect model in question
     *    var element         = ..; // dom element in question
     *
     *    var effectInstance = Effects.createFromModel(someEffectModel, element);
     *    // Use effect, e.g. call "play" or whatever...
     *    effectInstance.play()
     *    ..
     * </pre>
     */
    const Effects = Enum.create("Effect", map, {

        /**
         * Returns a new effect instance backed by the supplied effect model and dom element.
         *
         * @param   {AbstractWidgetView} widgetView The associated widget view; cannot be falsey.
         * @param   {EffectModel} model   The effect model to back the created effect; cannot be falsey.
         *
         * @returns {Effect} The corresponding effect instance, backed by <tt>model</tt>; never falsey.
         * @throws  {Error}  If no such effect exist or it cannot be created for what ever reason.
         */
        createFromModel(widgetView, model) {
            const EffectType = Effects.lookup(model.get("type"));
            return new EffectType(widgetView, model);
        }
    });

    return Effects;
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/effects/Effects.js